<template>
    <div>
        <!-- Shown when the backend returns a 403 (origin not in the allowed_origin whitelist). -->
        <div v-if="accessBlockedMessage" class="access-blocked-banner" role="alert">
            <span class="access-blocked-icon">⚠</span>
            {{ accessBlockedMessage }}
        </div>
        <div class="subjectContainer">
            <p
                tabindex="0"
                aria-live="assertive">
                    {{$gettext('Para obtener una atención personalizada, selecciona el tema de su consulta:')}}
            </p>
            <type-chat
                v-for="(type, index) in allChatOptions"
                :key="type.id"
                :index="index"
                :type="type"
                :url="url"
                >
            </type-chat>
        </div>
        <default-responses></default-responses>
    </div>
</template>

<script>
import TypeChat from '../TypeChat.vue';
import { mapState } from 'vuex';
import DefaultResponses from './DefaultResponses.vue';

export default {
    name: 'SelectSubject',
    components: {
        TypeChat,
        DefaultResponses
    },
    computed: {
        // accessBlockedMessage: drives the blocked-access banner defined above.
        ...mapState(['chatType', 'chatTypes', 'chatWindowStatus', 'waitingList', 'language', 'appointmentUrls', 'accessBlockedMessage']),
        allChatOptions() {
            return [...this.chatTypes, ...this.appointmentUrls];
        }
    },
    methods: {
    },
    mounted() {
    },
};
</script>

<style scoped>
.access-blocked-banner {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 8px 12px 4px;
    padding: 10px 14px;
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 6px;
    color: #664d03;
    font-size: 13px;
    line-height: 1.4;
}

.access-blocked-icon {
    flex-shrink: 0;
    font-style: normal;
}
</style>
